import { userInfoStore } from "Stores/UserInfoStore";
import { API_URL } from "General/APIEndpoints";

import { ArrayDataStore } from "Stores/RESTStoreInstances/ArrayDataStore";
import { SubmitStore } from "Stores/RESTStoreInstances/SubmitStore";
import { computed, makeObservable } from "mobx";
import { API } from "General/API";

export class ProjectGroupList extends ArrayDataStore<API_ProjectGroup> {
  constructor() {
    super();

    makeObservable(this, {
      projectGroups: computed,
    });

    this.data = [] as ArrayDataStore<API_ProjectGroup>["data"];
  }
  url(): string {
    return API_URL.PROJECTGROUPS.getProjectGroupsOfUser();
  }

  getShortName(id: number) {
    const data = this.find(id, "id");
    return data ? data.shortName : "";
  }

  getName(id: number | string) {
    const data = this.find(+id, "id");
    return data ? data.name : "";
  }

  getUserLoginMode(id: number | string) {
    const data = this.find(+id, "id");
    return data ? data.userLoginMode : "STANDARD";
  }

  prAdminRightUser(prGroupId: number | string): boolean {
    const group = this.find(+prGroupId, "id");

    return group?.createUser === true;
  }

  prAdminRightProject(prGroupId: number | string): boolean {
    const group = this.find(+prGroupId, "id");
    return group?.createProject === true;
  }

  get projectGroups() {
    if (userInfoStore.role === "PRGROUPADMIN") {
      return this.data.filter((val) => {
        return val.createUser;
      });
    } else {
      return this.data;
    }
  }

  processResponse = (response: API_ProjectGroups) => {
    return response.items;
  };

  updateData(projectId: number, newData: API_PGAdminProjectChanges) {
    try {
      return API.editData(API_URL.ADMIN_PROJECTS.updateProjectGroupProject(projectId), newData);
    } catch (error) {
      throw error;
    }
  }
}

export const projectGroupList = new ProjectGroupList();

export class PrGroupSubmitStore extends SubmitStore<API_ProjectGroup, API_ProjectGroup, ProjectGroupList> {
  url(id?: number) {
    if (id) {
      return API_URL.PROJECTGROUPS.getProjectGroupOfUser(id);
    } else {
      return API_URL.PROJECTGROUPS.getProjectGroupsOfUser();
    }
  }
}

export const prGroupSubmitStore = new PrGroupSubmitStore(projectGroupList);
